var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsiscirclefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.5254 85.6934-35.2539C85.6934-56.9824 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-56.9824 6.83594-35.2539C6.83594-13.5254 24.5117 4.15039 46.2402 4.15039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9414-29.248C61.6211-29.248 58.9355-31.9336 58.9355-35.2539C58.9355-38.5742 61.6211-41.2598 64.9414-41.2598C68.2129-41.2598 70.9473-38.5742 70.9473-35.2539C70.9473-31.9336 68.2129-29.248 64.9414-29.248Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402-29.248C42.9199-29.248 40.2344-31.9336 40.2344-35.2539C40.2344-38.5742 42.9199-41.2598 46.2402-41.2598C49.5605-41.2598 52.2949-38.5742 52.2949-35.2539C52.2949-31.9336 49.5605-29.248 46.2402-29.248Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5879-29.248C24.3164-29.248 21.582-31.9336 21.582-35.2539C21.582-38.5742 24.3164-41.2598 27.5879-41.2598C30.8594-41.2598 33.5938-38.5742 33.5938-35.2539C33.5938-31.9336 30.9082-29.248 27.5879-29.248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsiscirclefill);
export default __webpack_public_path__ + "static/media/ellipsis.circle.fill.b093b1a930f728ffe66ad2cde1fd8c21.svg";
export { ForwardRef as ReactComponent };